import ComponentElement from 'components/component-element';
import ReviewPhotogallery from './review-photogallery';
import {createElement} from 'methods/utils';
import Scroll from 'components/scroll';

export const VOTE_NONE =  0;
export const VOTE_UP   =  1;
export const VOTE_DOWN = -1;

/**
 * Класс отзыва
 * @param {Element} $element Элемент отзыва
 */
function Review($element, reviews, options = {}) {
    ComponentElement.call(this, $element, options);

    this.reviews = reviews;
    this.parent = this.options.parent;

    (($data) => {
        const data = JSON.parse($data.innerHTML);

        this.data = {
            id:        parseInt(data.id, 10),
            pid:       parseInt(data.pid, 10),
            mid:       parseInt(data.mid, 10),
            tid:       parseInt(data.tid, 10),
            replyId:   parseInt(data.reply_id, 10),
            userId:    parseInt(data.user_id, 10),
            userName:  data.user_name,
            vote:      parseInt(data.vote, 10),
            votesUp:   parseInt(data.votes_up, 10),
            votesDown: parseInt(data.votes_down, 10),
        };

        this.data.votesValue = this.data.votesUp - this.data.votesDown;
        $data.remove();
    })(this._primaryQuerySelector('.js-review-data'));

    this.$bodyContent           = this.$element.querySelector('.js-bodyContent');
    this.$replies               = this._primaryQuerySelector('.js-replies');
    this.$repliesMore           = this._primaryQuerySelector('.js-repliesMore');
    this.$repliesContainer      = this._primaryQuerySelector('.js-repliesContainer');
    this.$scrollToRepliedReview = this._primaryQuerySelector('.js-scrollToRepliedReview'); // кликабельное автора родительского комментария
    this.$votesContainer        = this._primaryQuerySelector('.js-votesContainer');        // блок голосований
    this.$photogallery          = this._primaryQuerySelector('.js-photogallery');          // фотогалерея
    this.$socialContainer       = this._primaryQuerySelector('.js-social-container');      // контейнер для социальных кнопок
    
    // обёртка для авторизации перед вызовом метода
    this.authProxy = (cb) => {
        return () => {
            this.reviews.auth().then(cb);
        }
    }

    this.$social = createElement(
        `<div class="Social js-social">
            <div class="Social__title">Было полезно?</div>
            <div class="Social__buttons">
                <div class="Social__buttons--votes js-votesContainer">
                    <button class="Social__button Social__button-vote--positive js-vote${this.data.vote == VOTE_UP ? ' is-active' : ''}" data-vote="${VOTE_UP}">Да${this.data.votes_up ? ` ${this.data.votes_up}` : ''}</button>
                    <button class="Social__button Social__button-vote--negative js-vote${this.data.vote == VOTE_DOWN ? ' is-active' : ''}" data-vote="${VOTE_DOWN}">Нет${this.data.votes_down ? ` ${this.data.votes_down}` : ''}</button>
                </div>
                <div class="Social__buttons--other">
                    <button class="Social__button Social__button--clean js-replyOpen">Ответить</button>
                </div>
            </div>
        </div>`
    );
    this.$socialContainer.appendChild(this.$social);

    this.$voteUp   = this._primaryQuerySelector(`.js-vote[data-vote="${VOTE_UP}"]`);
    this.$voteDown = this._primaryQuerySelector(`.js-vote[data-vote="${VOTE_DOWN}"]`);
    this.$votes    = [this.$voteUp, this.$voteDown];

    this.$votes.forEach($vote => {
        $vote.addEventListener('click', this.authProxy(this.onVoteButtonClickEvent.bind(this, $vote, $vote.dataset.vote)));
    });

    this.$social    = this._primaryQuerySelector('.js-social');    // блок с кнопками голосования
    this.$replyOpen = this._primaryQuerySelector('.js-replyOpen'); // кнопка "Ответить"

    if (this.$replyOpen) {
        this.$replyOpen.addEventListener('click', this.authProxy(this.replyToggle.bind(this)));
    }

    // показать больше ответов
    if (this.$repliesMore) {
        this.$repliesMore.addEventListener('click', e => {
            // от повторных кликов
            if (this.$repliesMore.classList.contains('is-loading')) {
                return;
            }
            this.$repliesMore.classList.add('is-loading');

            this.fetchReplies().then((html) => {
                // удаление кнопки
                this.$repliesMore.parentElement.removeChild(this.$repliesMore);

                const $fragment = createElement(`<div>${html}</div>`);
                $fragment.querySelectorAll(':scope > .js-review').forEach($reply => {
                    this.$repliesContainer.appendChild($reply);
                    const reply = this._initReply($reply);

                    this.replies.push(reply);
                });
            }).catch(() => {
                // возврат кнопки
                this.$repliesMore.classList.remove('is-loading');
            });
        });
    }

    // прокрутка до родительского отзыва
    if (this.$scrollToRepliedReview) {
        this.$scrollToRepliedReview.addEventListener('click', e => {
            clearTimeout(this.__scrollToReplyTimeout);
            this.parent.$bodyContent.style.backgroundColor = 'rgba(0, 137, 253, 0.15)';

            Scroll.to(this.parent.$element, {time: 0.3, offsetY: 150}).finally(() => {
                this.__scrollToReplyTimeout = setTimeout(() => {
                    this.parent.$bodyContent.style.backgroundColor = '';
                }, 400);
            });
        });
    }

    // фотогалерея
    if (this.$photogallery) {
        new ReviewPhotogallery(this.$photogallery);
    }

    // дочерние отзывы (ответы)
    this.replies = [...this.$repliesContainer.querySelectorAll(':scope > .js-review')].map(this._initReply.bind(this));

    this.bodyInitialContent = this.$bodyContent.innerHTML;

    // обновление состояний
    this.update();
}

Review.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Review.prototype, 'constructor', {
    value: Review,
    enumerable: false,
    writable: true,
});

Review.prototype.setOptions = function(options) {
    ComponentElement.prototype.setOptions.call(this, Object.assign({
        parent: null, // родительский отзыв
        negativeDimmingVotesValue: -10, // значение голосов при котором будет приглушаться отзыв
    }, options));
}

Review.prototype._onVotesChanged = function() {
    if (this.$bodyContent) {
        this.$bodyContent.classList.toggle('is-negative', this.data.votesValue <= this.options.negativeDimmingVotesValue);
    }
}

Review.prototype.update = function() {
    this._updateVoteButtons();
    this._onVotesChanged();
    this._updateText();
}

Review.prototype._updateText = function() {
    // от повторного срабатывания
    if (this.$readMore) {
        this.$readMore.remove();
        this.$bodyContent.innerHTML = this.bodyInitialContent;
    }

    // максимальная высота блока текста
    const lineHeight = window.getComputedStyle(this.$bodyContent).lineHeight || 0;
    const maxHeight = parseInt(lineHeight, 10) * 4; // максимум 4 строки

    if (this.$bodyContent.offsetHeight <= maxHeight) {
        return;
    }

    this.$readMore = createElement(
        `<span class="Review__read-more-unwrap js-readMoreUnwrap">Читать полностью</span>`
    );

    // парсинг предложений по знакам препинания
    const sentenses = [];
    let lastPos     = 0;
    this.$bodyContent.textContent.replace(/[.!?]+/g, (match, pos) => {
        sentenses.push(this.$bodyContent.textContent.slice(lastPos, pos + match.length));
        lastPos = pos + match.length;
    });

    // мало текста, можно без кнопки
    if (sentenses.length <= 1) {
        return;
    }

    let i = sentenses.length;
    while (i && this.$bodyContent.offsetHeight > maxHeight) {
        this.$bodyContent.textContent = sentenses.slice(0, i--).join('');
    }

    // клик по кнопке "Читать полностью"
    this.$readMore.addEventListener('click', e => {
        this.$bodyContent.removeChild(this.$readMore);
        this.$bodyContent.innerHTML = this.bodyInitialContent;
    });

    this.$bodyContent.appendChild(this.$readMore);
}

/**
 * Запрос ветки комментариев
 * @return {Promise} => (html)
 */
Review.prototype.fetchReplies = function() {
    const formData = new FormData();
    formData.append('id', this.data.id);

    this.replies.forEach(review => {
        formData.append('exclude[]', review.data.id);
    });

    return fetch('ajax_fetch_reviews/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw new Error(r);
        }

        return r.content;
    });
}

/**
 * querySelector с поиском по прямым наследникам
 * @param  {String}  query Запрос
 * @return {Element}
 */
Review.prototype._primaryQuerySelector = function(query) {
    const $element = this.$element.querySelector(query);
    if (!$element) {
        return null;
    }

    const $review = $element.closest('.js-review');

    return this.$element == $review ? $element : null;
}

Review.prototype.onVoteButtonClickEvent = function($vote, vote, e) {
    const voteBak      = this.data.vote;
    const votesUpBak   = this.data.votesUp;
    const votesDownBak = this.data.votesDown;

    // возврат предыдущего состояния
    const rollback = () => {
        $vote.classList.remove('is-active');

        if ($activeVote) {
            $activeVote.classList.add('is-active');
        }

        this.data.vote = voteBak;
        this.setVotesUp(votesUpBak);
        this.setVotesDown(votesDownBak);
    }

    // снятие активного состояния
    const $activeVote = this.$votes.find($vote => $vote.classList.contains('is-active'));
    if ($activeVote) {
        $activeVote.classList.remove('is-active');

        if (this.data.vote == VOTE_UP) {
            this.setVotesUp(this.data.votesUp - 1);
        }

        if (this.data.vote == VOTE_DOWN) {
            this.setVotesDown(this.data.votesDown - 1);
        }
    }

    this.data.vote = vote;

    // нажали на активную кнопку - снятие голоса
    if ($vote == $activeVote) {
        this.unvote(vote).catch(rollback);
        return;
    }

    $vote.classList.add('is-active');

    if (vote == VOTE_UP) {
        this.setVotesUp(this.data.votesUp + 1);
    }

    if (vote == VOTE_DOWN) {
        this.setVotesDown(this.data.votesDown + 1);
    }

    this.vote(vote).catch(rollback);
}

Review.prototype.setVotesUp = function(value) {
    this.data.votesUp = value;
    this._updateVoteButtons();
}

Review.prototype.setVotesDown = function(value) {
    this.data.votesDown = value;
    this._updateVoteButtons();
}

/**
 * Оставить голос
 * @param {Number} vote Сила голоса (-1, 1)
 */
Review.prototype.vote = function(vote) {
    this._disableVoteButtons();

    const formData = new FormData();
    formData.append('id', this.data.id);
    formData.append('vote', vote);

    return fetch('ajax_vote/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status == 'error') {
            throw new Error('Voting error');
        }

        this.emit('vote', vote);
    })
    .finally(() => {
        this._enableVoteButtons();
        this._updateVoteButtons();
    });
}

/**
 * Забрать голос
 */
Review.prototype.unvote = function(vote) {
    this._disableVoteButtons();

    const formData = new FormData();
    formData.append('id', this.data.id);

    return fetch('ajax_unvote/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status == 'error') {
            throw new Error('Voting error');
        }

        this.emit('unvote', vote);
    })
    .finally(() => {
        this._enableVoteButtons();
        this._updateVoteButtons();
    });
}

Review.prototype._disableVoteButtons = function() {
    this.$votes.forEach($button => $button.disabled = true);
}

Review.prototype._enableVoteButtons = function() {
    this.$votes.forEach($button => $button.disabled = false);
}

/**
 * Обновление голосов
 */
Review.prototype._updateVoteButtons = function() {
    this.$voteUp.textContent   = `Да${this.data.votesUp ? ` (${this.data.votesUp})` : ''}`;
    this.$voteDown.textContent = `Нет${this.data.votesDown ? ` (${this.data.votesDown})` : ''}`;
}
/**
 * Показ поля ввода
 */
Review.prototype.replyOpen = function() {
    if (!this.$reply) {
        this.$reply = createElement(
            `<div class="Reply js-reply">
                <div class="Reply__name">
                    <div class="Reply-to Reply-to--disabled">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9997_52872)">
                            <path d="M15 14L20 9L15 4" stroke="#6A6D81" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M4 20V13C4 11.9391 4.42143 10.9217 5.17157 10.1716C5.92172 9.42143 6.93913 9 8 9H20" stroke="#6A6D81" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </g>
                            <defs>
                            <clipPath id="clip0_9997_52872">
                            <rect width="24" height="24" fill="white"></rect>
                            </clipPath>
                            </defs>
                        </svg>
                        <div class="Reply-to__name">${this.data.userName}</div>
                    </div>
                </div>
                <div class="Reply__input">
                    <textarea placeholder="Напишите комментарий"></textarea>
                </div>
                <div class="Reply__buttons">
                    <button class="Reply__button Reply__button--submit Button Button--shaded-blue js-submit" title="Ctrl + Enter для отправки" disabled>Отправить</button>
                    <button class="Reply__button Reply__button--cancel js-close">Отменить</button>
                </div>
            </div>`
        );

        // кнопка отмены
        this.$close = this.$reply.querySelector('.js-close');
        this.$close.addEventListener('click', this.replyClose.bind(this));

        // кнопка отправки
        this.$submit = this.$reply.querySelector('.js-submit');
        this.$submit.addEventListener('click', e => {
            this._onReplySubmitClick();
        });

        // состояние кнопки отправки при вводе текста
        this.$textarea = this.$reply.querySelector('textarea');
        this.$textarea.addEventListener('input', e => {
            this.$submit.toggleAttribute('disabled', !this.$textarea.value.replace(/\s/g, '').length);
        });

        // нажали ctrl + enter
        this.$textarea.addEventListener('keydown', e => {
            if (e.ctrlKey && e.keyCode == 13) {
                this._onReplySubmitClick();
            }
        });

        this.$social.appendChild(this.$reply);
    }

    this.$reply.classList.remove('is-hidden');
    this.$textarea.focus();
}

/**
 * Скрытие поля ввода
 */
Review.prototype.replyClose = function() {
    this.$reply.classList.add('is-hidden');
}

/**
 * Показ / скрытие поля ввода
 * @return {[type]} [description]
 */
Review.prototype.replyToggle = function() {
    if (!this.$reply || this.$reply.classList.contains('is-hidden')) {
        this.replyOpen();
    } else {
        this.replyClose();
    }
}

/**
 * Нажатие на кнопку отправки
 */
Review.prototype._onReplySubmitClick = function() {
    // от повторных кликов
    if (this.$submit.hasAttribute('disabled')) {
        return;
    }

    // валидация
    const content = this.$textarea.value;
    if (!content.trim().length) {
        return;
    }

    this.$submit.toggleAttribute('disabled', true);
    this.reply(content)
        .then((html) => {
            const $reply = createElement(html);
            this.$repliesContainer.appendChild($reply);
            const reply = this._initReply($reply);

            this.replies.push(reply);

            this.$textarea.value = '';
            this.replyClose();

            // прокрутка до ответа на отзыв
            Scroll.to($reply, {time: 0.3, offsetY: window.innerHeight / 2 - $reply.offsetHeight / 2});
        })
        .catch(err => alert(err.message))
        .finally(() => {
            this.$submit.toggleAttribute('disabled', false);
        })
    ;
}

/**
 * Отправка ответа на отзыв
 */
Review.prototype.reply = function(content) {
    const formData = new FormData();
    formData.append('reply_id', this.data.id);
    formData.append('content', content);

    return fetch('ajax_create_review/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok' || !r.data || !r.data.content) {
            throw new Error(r.message || 'Ошибка отправки');
        }

        return r.data.content;
    });
}

/**
 * Инициализация ответа
 * @param  {HTMLElement} $reply Элемент ответа
 * @return {Review}
 */
Review.prototype._initReply = function($reply) {
    const reply = new Review($reply, this.reviews, {
        parent: this,
    });

    return reply;
}

/**
 * Запрос отзыва
 * @param  {Number}  id Идентификатор отзыва
 * @return {Promise}
 */
Review.fetch = function(id) {
    id = parseInt(id, 10);
    if (!id) {
        return Promise.reject('Invalid id');
    }

    if (!Review.fetch._cache) {
        Review.fetch._cache = {};
    }

    if (Review.fetch._cache[id]) {
        return Review.fetch._cache[id];
    }

    return Review.fetch._cache[id] = fetch('ajax_fetch_review/?id=' + id, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw new Error(r.message);
        }

        return r.content;
    });
};

export default Review;
